<template>
  <div>
    <h1>{{ $t("delegation.decision.title") }}</h1>
    <div class="mt-3 elevation-12 grey lighten-4">
      <div class="pa-4">
        <delegation-decision-form
          :delegation-decision.sync="delegationDecision"
          @accept="accept"
          @deny="deny"
          @denyAndRevert="denyAndRevert"
          @downloadAllFiles="downloadAttachments"
          @downloadSettlement="downloadSettlement"
          @settle="settle"
        />
      </div>
      <v-card class="grey lighten-4">
        <v-card-actions>
          <v-spacer />
          <v-btn @click.native="window.close()" color="blue darken-1" text>{{ $t("global.close") }}</v-btn>
        </v-card-actions>
      </v-card>
    </div>
  </div>
</template>

<script>
import fileDownloadFunction from "../../../repository/downloadFile";
import DelegationDecisionForm from "../../../components/Delegation/DelegationDecisionForm";

export default {
  name: "ActionByLinkDelegationDecisionView",
  components: { DelegationDecisionForm },
  data: () => ({
    delegationDecision: {
      additionalCostsShow: false
    }
  }),
  created() {
    // if (!(this.$route.params.type === 'financial' || this.$route.params.type === 'substantial')) {
    //     this.$router.push('/delegation');
    // }
    this.downloadDelegationDecision();
  },
  methods: {
    downloadSettlement() {
      fileDownloadFunction("token/delegation/document-preview?token=" + this.$route.params.token);
    },
    downloadAttachments() {
      fileDownloadFunction("token/delegation/all-files?token=" + this.$route.params.token);
    },
    downloadDelegationDecision() {
      this.axios
        .get("token/delegation/get-decision?token=" + this.$route.params.token)
        .then(resp => {
          this.delegationDecision = resp.data;
        })
        .catch(() => {
          //console.log(err);
          this.$router.push("/action-by-link/" + this.$route.params.token);
        });
    },
    accept() {
      this.axios({
        url: "token/delegation/accept",
        data: { token: this.$route.params.token },
        method: "POST"
      })
        .then(resp => {
          if (resp.data.status === "OK") {
            this.$router.push("/action-by-link/" + this.$route.params.token);
          } else if (resp.data.status === "error") {
            //TODO WYSWIETLENIE DYMKA BLEDU WALIDACJI
          }
        })
        .catch(() => {
          //TODO obsluga bledow
        });
    },
    settle() {
      this.axios({
        url: "token/delegation/settle",
        data: { token: this.$route.params.token },
        method: "POST"
      })
        .then(resp => {
          if (resp.data.status === "OK") {
            this.$router.push("/action-by-link/" + this.$route.params.token);
          } else if (resp.data.status === "error") {
            //TODO WYSWIETLENIE DYMKA BLEDU WALIDACJI
          }
        })
        .catch(() => {
          //TODO obsluga bledow
        });
    },
    deny(promptText) {
      this.axios({
        url: "token/delegation/reject",
        data: {
          token: this.$route.params.token,
          reason: promptText
        },
        method: "POST"
      })
        .then(resp => {
          if (resp.data.status === "OK") {
            this.$router.push("/action-by-link/" + this.$route.params.token);
          } else if (resp.data.status === "error") {
            //TODO WYSWIETLENIE DYMKA BLEDU WALIDACJI
          }
        })
        .catch(() => {
          //TODO obsluga bledow
        });
    },
    denyAndRevert(promptText) {
      this.axios({
        url: "token/delegation/reject-and-back",
        data: {
          token: this.$route.params.token,
          reason: promptText
        },
        method: "POST"
      })
        .then(resp => {
          if (resp.data.status === "OK") {
            this.$router.push("/action-by-link/" + this.$route.params.token);
          } else if (resp.data.status === "error") {
            //TODO WYSWIETLENIE DYMKA BLEDU WALIDACJI
          }
        })
        .catch(() => {
          //TODO obsluga bledow
        });
    }
  },

  mounted() {
    this.$store.dispatch("Visual/setHalfBackground");
  },
  beforeDestroy() {
    this.$store.dispatch("Visual/setWhiteBackground");
  }
};
</script>

<style scoped></style>
